// Store-wide pricing rules. Keep in sync with backend/utils/pricing.js.
export const FREE_SHIPPING_MIN = 699;
export const SHIPPING_FEE = 69;
export const DISCOUNT_MIN = 1999;
export const DISCOUNT_PERCENT = 10;
export const FREE_GIFT_MIN = 3999;
export const COD_FEE = 100;

export function calcPricing(subtotal, paymentMethod) {
  const shippingFee = subtotal >= FREE_SHIPPING_MIN ? 0 : SHIPPING_FEE;
  const discount =
    subtotal >= DISCOUNT_MIN
      ? Math.round((subtotal * DISCOUNT_PERCENT) / 100)
      : 0;
  const codFee = paymentMethod === "cod" ? COD_FEE : 0;
  const freeGift = subtotal >= FREE_GIFT_MIN;
  const total = subtotal - discount + shippingFee + codFee;
  return {subtotal, shippingFee, discount, codFee, freeGift, total};
}

// Next unlockable perk, e.g. "Add ₹300 more for free shipping"
export function nextOfferHint(subtotal) {
  if (subtotal < FREE_SHIPPING_MIN)
    return `Add ₹${(FREE_SHIPPING_MIN - subtotal).toLocaleString("en-IN")} more for free shipping`;
  if (subtotal < DISCOUNT_MIN)
    return `Add ₹${(DISCOUNT_MIN - subtotal).toLocaleString("en-IN")} more to get ${DISCOUNT_PERCENT}% off`;
  if (subtotal < FREE_GIFT_MIN)
    return `Add ₹${(FREE_GIFT_MIN - subtotal).toLocaleString("en-IN")} more for a surprise gift 🎁`;
  return null;
}
